import { useState } from 'react';
import { Button } from '@/ui/Button';
import { Dialog } from '@/ui/Dialog';
import { Field, Input, Textarea } from '@/ui/Field';
import { useEnviarPorCorreo } from './api';

/**
 * Correo — enviar un registro por correo.
 *
 * Es un diálogo y no un panel porque manda algo fuera del portal: es de las
 * pocas acciones de esta pantalla que salen del sistema, y conviene que
 * interrumpa.
 */
export function Correo({ id, onCerrar }: { id: number; onCerrar: () => void }) {
  const enviar = useEnviarPorCorreo();
  const [para, setPara] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  function mandar() {
    if (!para.trim()) { setError('Escribe al menos un destinatario.'); return; }
    enviar.mutate(
      { id, to: para.trim(), message: mensaje.trim() || null },
      {
        onSuccess: (r) => { Utils.toast(r.message, 'success'); onCerrar(); },
        onError: (err) => setError(err instanceof Error ? err.message : 'No se pudo enviar'),
      },
    );
  }

  return (
    <Dialog
      abierto
      onCambio={(v) => { if (!v && !enviar.isPending) onCerrar(); }}
      titulo="Enviar el registro por correo"
      descripcion="Va con el pie estándar del portal y queda constancia en la auditoría."
      pie={
        <>
          <Button variant="ghost" onClick={onCerrar}>Cancelar</Button>
          <Button onClick={mandar} loading={enviar.isPending}>
            <i className="bi bi-send" aria-hidden="true" /> Enviar
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4 pb-2">
        <Field label="Para" ayuda="Separa varios con comas." error={error || undefined}>
          <Input
            type="text"
            inputMode="email"
            value={para}
            onChange={(e) => { setPara(e.target.value); setError(''); }}
            placeholder="alguien@empresa.com, otra@empresa.com"
          />
        </Field>
        <Field label="Mensaje" opcional>
          <Textarea rows={2} value={mensaje} onChange={(e) => setMensaje(e.target.value)} />
        </Field>
      </div>
    </Dialog>
  );
}
